import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/safras/actions';

import Form from './form';

function Safras() {
  const redux = useSelector((state) => state.safras);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = useMemo(
    () => [
      {
        id: 'idsafra',
        label: t('s.cadastro.safra.idsafra'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaosafra',
        label: t('s.cadastro.safra.descricaosafra'),
        filter: { type: 'text' },
      },
      {
        id: 'statussafra',
        label: t('s.cadastro.safra.statussafra'),
        formatted: (value) => status.find((s) => s.label === value).label || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idsafra"
      detach="idsafra"
    />
  );
}

export default Safras;
